<template>
	<div class="position-relative">
    <div v-if="is_load" class="w-100 py-4 text-center" style="min-height: calc(100vh - 74px);">
      <loader />
    </div>
    <div class="w-100" style="min-height: calc(100vh - 74px);" v-else>
    	<div class="px-4" v-if="error != ''">
      	<ErrorMessage :message="error" />
    	</div>
      <template v-else>
      	<!-- GENERAL -->
      	<div class="px-4" v-if="menu === 'general'">
      		<wrapper-mobile-view>
						<div class="w-100 bg-white py-3 px-4 border-b-semi-grey">
							<div class="w-100">
								<div class="row">
									<div class="col-1 align-self-center">
										<div @click="backTo()" class="d-inline-grid cursor-pointer">
	                    <img src="../../../assets/img/icon/back.png" alt="Back" class="mt-1" width="20">
	                  </div>
									</div>
									<div class="col-9 align-self-center">
										<p class="mb-0 body-1-2">{{$t('general.account')}}</p>
									</div>
								</div>
							</div>
						</div>
					</wrapper-mobile-view>
					<block :height="57" />
      		<div class="row slim-grid-row mt-4 mb-3 py-2">
		    		<div class="col-12 align-self-center">
		    			<div class="d-inline-block align-middle mr-3">
		    				<div class="cursor-pointer" @click="is_profile = true">
		    					<img v-if="isNotLogin" src="../../../assets/img/icon/question.png" class="border-profil img-profil rounded-100">
		    					<div v-else :style="{'background-image': 'url('+getCurrentUser.avatar+')'}" class="border-profil border-2-green rounded-100 cursor-pointer img-profil" style="padding:1px"></div>
		    				</div>
		    			</div>
		    			<div class="d-inline-block align-middle" style="width: 60%;">
		    				<template v-if="isNotLogin">
			    				<p class="mb-0 body-1-4 text-20 text-truncate" @click="goLoginPage()">{{$t('warning-message.not-logged-in')}}</p>
				    			<p class="mb-0 body-2-2 text-truncate text-green font-semibold cursor-pointer" @click="goLoginPage()"><u>{{$t('general.login-now')}}</u></p>
			    			</template>
			    			<template v-else>
				    			<p class="mb-0 body-1-4 text-20 text-truncate">{{getCurrentUser.first_name+' '+ (getCurrentUser.last_name != null ? getCurrentUser.last_name : '')}}</p>
				    			<template v-if="membership.id">
	                  <i :style="{color:membership.card_color_accent}" style="font-size:18px;" class="d-inline-block align-middle simple-icon-credit-card"></i>
	                  <p class="mb-0 body-2-2 d-inline-block align-middle ml-1">{{membership.card_name}} {{$t('hotel.concierge.member')}}</p>
	                </template>
				    			<p v-else class="mb-0 body-2-2 text-truncate">{{getCurrentUser.email}}</p>
				    		</template>
		    			</div>
			    	</div>
			    </div>

			    <!-- RESERVATION DETAIL -->
			    <div class="w-100 mb-5" v-if="isReservationActive">
						<div class="w-100 border-semi-grey radius-8 p-3">
							<div class="row no-gutters">
								<div class="col-12 text-center py-3" v-if="reservation_load">
									<loader />
								</div>
								<template v-else>
									<div class="col-2 align-self-center">
										<div class="w-100 pr-2">
											<div class="w-100 bg-orange text-center radius-8" style="padding:13px 0px;">
												<i class="simple-icon-home text-18 text-white"></i>
											</div>
										</div>
									</div>
									<div class="col-7 align-self-center">
										<div class="pr-2">
											<p class="mb-0 body-2-1" :class="{'text-danger': reservation.room_type.name == 'Unallocated Room Type'}">{{reservation.room_type.name}}</p>
											<div class="w-100 no-ws">
												<p class="mb-0 d-inline-block align-middle body-3-3-1 mr-2">Room : </p>
												<p class="mb-0 d-inline-block align-middle body-3-1" :class="{'text-danger': reservation.room.name == 'Unallocated'}">{{reservation.room.name}}</p>
											</div>
											<p class="mb-0 body-3-1 text-info">Folio {{reservation.folio_number != '' ? `#${reservation.folio_number}` : '#'}}</p>
										</div>
									</div>
									<div class="col-3 align-self-center text-right">
										<p class="mb-0 body-3-3-1">Status</p>
										<p class="mb-0 body-3-1" :class="reservation_status.text_color">{{reservation_status.title}}</p>
									</div>
									<div class="col-12 my-3">
										<div class="w-100 border-2-bottom-dashed"></div>
									</div>
									<div class="col-6">
										<p class="mb-0 body-3-3-1">Check in</p>
										<p class="mb-0 body-3-1">{{$formatDate(reservation.arrival_date,'YYYY-MM-DD')}}</p>
									</div>
									<div class="col-6">
										<p class="mb-0 body-3-3-1">Check out</p>
										<p class="mb-0 body-3-1">{{$formatDate(reservation.departure_date,'YYYY-MM-DD')}}</p>
									</div>
									<div class="col-12 my-3">
										<div class="w-100 border-b-semi-grey"></div>
									</div>
									<div class="col-12 mt-2" v-if="reservation.status == 'SUBMIT_FORM' || reservation.status == 'PRE_CHECKIN' || reservation.status == 'CHECKIN' || (getMerchant.reservation_detail_show_bill && isCurrentUserSameWithRsvUser)">
										<button type="button" v-if="reservation.status == 'SUBMIT_FORM' || reservation.status == 'PRE_CHECKIN'" class="g-btn w-100 g-btn-primary g-btn-md" :class="getMerchant.reservation_detail_show_bill && isCurrentUserSameWithRsvUser ? 'mb-2' : ''" @click="loadDetailReservation()">Check Status</button>
										<button v-if="getMerchant.reservation_detail_show_bill && isCurrentUserSameWithRsvUser" type="button" class="g-btn w-100 g-btn-secondary-outline g-btn-md" @click="openGuestBill()">Guest Bill</button>
									</div>
								</template>
							</div>
						</div>
					</div>

					<div class="border-bottom-6"></div>

			    <div class="w-100" v-for="menu in menus" v-if="!isNotLogin">
				    <div class="mb-2 pt-3 pb-3 cursor-pointer border-bottom" @click="clickMenu(menu.code)">
							<div class="row">
								<div class="col-10 align-self-center" :class="{'text-danger': menu.title == 'Logout'}">
									<i class="d-inline-block align-middle mr-3 body-2-2 text-16 bold" :class="menu.icon" :style="{color: menu.color}"></i>
									<p class="mb-0 d-inline-block align-middle body-2-2 text-16 font-semibold" :class="{'text-danger': menu.title == 'Logout'}">{{menu.title}}</p>
								</div>
								<div class="col-2 align-self-center text-right">
									<i class="simple-icon-arrow-right text-14 body-2-2" :class="{'text-danger': menu.title == 'Logout'}"></i>
								</div>
							</div>
						</div>
					</div>
    		</div>

    		<!-- EDIT PROFILE -->
    		<EditProfile v-if="menu == 'edit-profile'" @back="clickMenu()"></EditProfile>

    		<!-- CHANGE PASSWORD -->
    		<ChangePassword v-if="menu == 'change-password'" @back="clickMenu()"></ChangePassword>

    		<!-- CHANGE LANGUAGE -->
    		<ChangeLanguage v-if="menu == 'language'" @back="clickMenu()"></ChangeLanguage>

    		<!-- RESERVATION LIST -->
    		<ReservationList v-if="menu == 'h-history'" @back="clickMenu()"></ReservationList>
    	</template>
	   

	    <!-- PROFILE -->
	    <transition name="fade">
	    	<template v-if="is_profile">
	        <div class="fixed-top d-block nav-bottom">
	          <div class="custom-container-fluid px-0">
	            <div class="row justify-content-center no-gutters">
	              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative cursor-pointer" @click="is_profile = false">
	                <div class="hide-scroll overflow-scroll" style="background-color:rgba(30, 30, 30, 0.9);z-index: 1055;height: 100vh;">
	                  <div class="w-100">
	                    <div class="text-center box-shadow-1 rounded">
	                      <div class="w-100 pop-up-body">
	                        <!-- <div
	                          class="position-fixed rounded cursor-pointer close-p"
	                          @click="is_profile = false">
	                          <img src="../../../assets/img/icon/cancel.png" class="m-2" width="15" />
	                        </div> -->
													<div class="img-p-c">
														<img v-if="isNotLogin" src="../../../assets/img/icon/question.png" class="d-block m-auto w-100 object-fit" height="250">
														<img v-else :src="getCurrentUser.avatar" class="d-block m-auto w-100 object-fit" height="250">
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</template>
			</transition>


    </div>
    <!-- GUEST BILL -->
    <GuestBill ref="guest_bill"></GuestBill>

    <BottomNavbar v-if="getMerchant.merchant_type == 'restaurant'" page="ACCOUNT" />
  </div>
</template>
<script>
	import {mapGetters,mapMutations,mapActions} from "vuex";
	import EditProfile from '@/pages/general/account/EditProfile'
	import ChangePassword from '@/pages/general/account/ChangePassword'
	import ChangeLanguage from '@/pages/general/account/ChangeLanguage'
	import Membership from '@/pages/general/account/Membership2'
	import ReservationList from '@/pages/general/account/ReservationList'
	import GuestBill from '@/components/hotel/general/GuestBill'
	import {get,post} from '@/services/index.js';
  import BottomNavbar from "../../../components/restaurant-v2/BottomNavbar.vue";
  
	export default{
		components:{
			EditProfile,
			ChangePassword,
			ChangeLanguage,
			ReservationList,
			Membership,
			GuestBill,
      BottomNavbar
		},
		metaInfo(){
      return {
        title: 'Account',
        titleTemplate: this.getMetaTitleTemplate
      }
    },
		data(){
			return{
				is_load: true,
				error: '',
				membership: {},
				menu: 'general',
				menus: [],
				is_profile: false,
				reservation: {},
				reservation_load: false,
				reservation_pin: '',
        reservation_pin_error: ''
			}
		},
		computed:{
			...mapGetters(['getMerchant','getCurrentUser','getMetaTitleTemplate','isNotLogin','getActiveRoute','getConciergeAuth','getIsConciergeAuth','isReservationActive','isCurrentUserSameWithRsvUser','isLoggedIn','getReservationActive']),
			reservation_status(){
				if(this.reservation.id){
					let return_data = {
						title: '',
						text_color: '',
						description: ''
					}

					if(this.reservation.status == 'SUBMIT_FORM'){
						return_data = {
							title: 'Waiting for Approval',
							text_color: 'text-secondary',
							description: 'Your data is waiting for approval by the front office. Please wait until the process done.'
						}
					}else if(this.reservation.status == 'PRE_CHECKIN' || this.reservation.status == 'CHECKIN'){
						return_data = {
							title: this.reservation.status == 'PRE_CHECKIN' ? 'Pre Check In' : 'Check In',
							text_color: this.reservation.status == 'PRE_CHECKIN' ? 'text-info' : 'text-success',
							description: 'Make yourself comfortable and enjoy all the services we have provided for you.'
						}
						if(this.isLoggedIn){
							if(!this.isCurrentUserSameWithRsvUser){
								return_data.description = 'This reservation is connected to a guestaps account that is different from your current account. If you want to log in with that account, you can open a message containing the auto login url in your email'
							}
						}else{
							return_data.description = 'Your data has been validated. There are many offers if you log in with a Guestaps account, please check your email for automatic login to your Guestaps account'
						}
					}

					return return_data
				}else{
					return null
				}
			},
		},
		mounted(){
			this.loadFirstData()
			document.addEventListener("keydown", (e) => {
        if (e.keyCode == 27) {
          this.is_profile = false;
        }
	    });
		},
		destroyed(){
    	this.setActiveRoute('')
    },
		methods:{
			...mapActions(['setLanguage','setToken','setUser','logout']),
    	...mapMutations(['setActiveRoute','resetOtherModule','setConciergeAuth','resetConciergeAuth','setConciergeReservation','setReservationActive']),
    	openGuestBill(){
				this.$refs.guest_bill.toggleDetail()
			},
			loadCurrentUser(){
				return new Promise((success,fail)=>{
					get("BASE","auth/profile").then(response=>{
	          this.setUser(response.data.user)
	          success()
	        })	
				})
			},
			checkStatusMember(){
				return new Promise((success,fail)=>{
	        get("CONCIERGE","membership/user-member-card-detail",{
	          merchant_id: this.getMerchant.id
	        }).then(response=>{
	          let res = response.data
	        	if(res.code == 'MEMBER' && this.getMerchant.use_membership){
	        		this.membership = res.data
	        	}else{
	        		this.membership = {}
	        	}
	        	success()
	        })
				})
      },
			loadFirstData(){
				this.initMenu()
				if(!this.isNotLogin){
					this.is_load = true
					this.error = ''
					let func_exc = [this.loadCurrentUser()]
					if(this.getMerchant.merchant_type == 'hotel'){
						func_exc.push(this.checkStatusMember())
						if(this.isReservationActive){
							func_exc.push(this.loadDetailReservation())
						}
					}
					Promise.all(func_exc)
					.then(response=>{
						this.menus.splice(0,0,
							{
								title: 'Edit Profile',
								icon: 'simple-icon-user',
								code: 'edit-profile',
							},
							{
								title: 'Change Password',
								icon: 'simple-icon-settings',
								code: 'change-password',
							}
						)
						if(this.getMerchant.merchant_type == 'hotel'){
							if(this.membership.id){
								this.menus.splice(2,0,
									{
			        			title: this.$t('hotel.menu.my-reward'),
										icon: 'simple-icon-badge',
										code: 'reward',
			        		},
									{
										title: this.$t('hotel.menu.history'),
										icon: 'simple-icon-event',
										code: 'h-history',
									}
								)
							}
						}else if(this.getMerchant.merchant_type == 'restaurant'){
							this.menus.splice(2,0,
								{
									title: this.$t('general.order-history'),
									icon: 'simple-icon-notebook',
									code: 'r-history',
								},
                {
									title: "Saved Address",
									icon: 'simple-icon-location-pin',
									code: 'saved-address',
								},
								// {
								// 	title: this.$t('profile.table-grid'),
								// 	icon: 'simple-icon-notebook',
								// 	code: 'r-table-history',
								// },
							)
						}else if(this.getMerchant.merchant_type == 'ticket'){
							this.menus.splice(2,0,
								{
									title: this.$t('profile.tiket-orders'),
									icon: 'simple-icon-event',
									code: 't-history',
								},
							)
						}
						if(this.$isNotEmpty(this.getMerchant.use_getplus) && this.getMerchant.use_getplus == 1){
							this.menus.push({
								title: 'Account Integration',
								icon: 'simple-icon-link',
								code: 'integration',
								is_need_auth: true
							})
						}
						this.menus.push({
							title: 'Logout',
							icon: 'simple-icon-logout',
							code: 'logout',
							is_need_auth: true,
							color: '#dc3545'
						})
					})
					.catch(err=>{
						console.log("err :", err)
						this.error = err
					})
					.finally(()=>{
						this.is_load = false
					})
				}else{
					this.is_load = false
				}
			},
			loadDetailReservation(){
				return new Promise((success,fail)=>{
					this.reservation_load = true
          get("CONCIERGE",`reservation/${this.getReservationActive.detail_id}`,{
            merchant_id: this.getMerchant.id
          }).then(response=>{
						let res = response.data
            if(res.success){
							let resv = res.data
							if(this.$isReservationValid(resv)){
								this.reservation = resv
								if(!this.$isNotEmpty(resv.room_type)){
									this.reservation.room_type = {}
									this.reservation.room_type.name = 'Unallocated Room Type'
								}
								if(!this.$isNotEmpty(resv.room)){
									this.reservation.room = {}
									this.reservation.room.name = 'Unallocated'
								}
								this.reservation_load = false
								success()
							} else{
								this.setReservationActive('reset')
								this.reservation_load = false
								success()
							}
            }else{
							this.reservation_load = false
              fail(res.message)
            }
          })
        })
			},
			initMenu(){
				this.menus = [
					{
						title: this.$t('hotel.menu.language'),
						icon: 'simple-icon-globe',
						code: 'language',
					}
				]
			},
			backTo(){
    		if(this.getActiveRoute != ''){
    			this.$router.push({
						path: '/'+this.getMerchant.code+'/'+this.getActiveRoute
					})
    		}else{
    			this.$router.push({
						path: '/'+this.getMerchant.code
					})
    		}
    	},
    	clickMenu(menu='general'){
    		if(menu == 'logout'){
    			this.logout()
    		}
    		if(menu == 'general'){
    			this.loadFirstData()
    		}
    		if(menu == 'r-history'){
    			this.$router.push(`/${this.getMerchant.code}/r/order-history`)
    		}
        if(menu == 'saved-address'){
    			this.$router.push(`/${this.getMerchant.code}/account/saved-address`)
    		}
    		if(menu == 'r-table-history'){
    			this.$router.push(`/${this.getMerchant.code}/r/order-history?type=table`)
    		}
    		if(menu == 't-history'){
  				this.$router.push(`/${this.getMerchant.code}/ticket/order-history`)
    		}
				if(menu == 'reward'){
  				this.$router.push(`/${this.getMerchant.code}/member`)
    		}
				if(menu == 'integration'){
  				this.$router.push(`/${this.getMerchant.code}/account/integration`)
    		}
    		this.menu = menu == 'logout' ? 'general' : menu
    	},
    	goLoginPage(){
				this.$router.push({
					path: '/'+this.getMerchant.code+'/login'
				})
			},
			goTableReservation(){
      	this.$router.push({
	        name: "RestaurantOrderHistory",
	        params: { type : 'table'},
	      });
      },
		}
	}
</script>
<style type="text/css">
	.close-p{
		margin: 10px 23px;
    background-color: rgba(0, 0, 0, 0.41);
    z-index: 9;
    right: 0;
    top: 100px;
	}
	.img-p-c{
		position: relative;
		top: 200px;
	}
</style>


// WEBPACK FOOTER //
// src/pages/general/account/General.vue